// ======================================================================
// FILE: src/modules/wms/work/pages/WorkFormPage.js
// MODULE: Work Management System (WMS)
// FEATURE: Work Management
//
// PURPOSE:
//   Create / Edit Work
//   Template Based Work
//   Adhoc Work
//
// ROUTES:
//   /wms/works/create
//   /wms/works/:id/edit
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";



import {
  useNavigate,
  useParams,
} from "react-router-dom";

import wmsTemplateService
from "../../services/wmsTemplateService";

import wmsChecklistService
from "../../services/wmsChecklistService";

import wmsTeamService
from "../../services/wmsTeamService";

import wmsWorkService
from "../../services/wmsWorkService";

import RecurringScheduleCard
from "../components/RecurringScheduleCard";

export default function WorkFormPage() {

  const navigate =
    useNavigate();

  const { id } =
    useParams();

  const isEdit =
    !!id;

  const [saving, setSaving] =
    useState(false);
    
    const [templates, setTemplates] =
      useState([]);
    const [
    selectedTemplateItems,
        setSelectedTemplateItems
    ] = useState([]);
    
    const [    selectedTemplate,    setSelectedTemplate  ] = useState(null);

    const [    templateItems,    setTemplateItems  ] = useState([]);

    const [checklists, setChecklists] =
      useState([]);
      const [
  selectedChecklistId,
  setSelectedChecklistId
] = useState("");

const [
  attachedChecklists,
  setAttachedChecklists
] = useState([]);

const [teams, setTeams] =
  useState([]);

const [teamMembers, setTeamMembers] =
  useState([]);

const [
  selectedMembers,
  setSelectedMembers
] = useState([]);

const [
  allTeamMembers,
  setAllTeamMembers
] = useState([]);

const [
  selectedOwners,
  setSelectedOwners
] = useState([]);

const [
  selectedApprovers,
  setSelectedApprovers
] = useState([]);


    const [form, setForm] =
      useState({

      work_mode:
        "ADHOC",

      title: "",

      description: "",

      template_id: "",

      department_id: "",

      location_id: "",

      priority:
        "MEDIUM",

      planned_due_date: "",

      estimated_minutes: "",

      

      team_id: "",
       watcher_ids: [],

      approval_required:
        false,

      sla_policy_id: "",

      escalation_policy_id: "",

      calendar_id: "",

      is_recurring:
        false,

      remarks: "",
    });
    useEffect(() => {

  loadMasters();

}, []);
useEffect(() => {

    if (isEdit) {

        loadWork(id);

    }

}, [id]);


const [
    schedule,
    setSchedule
] = useState({

    schedule_name: "",

    frequency: "DAILY",

    interval_value: 1,

    start_date: "",

    end_date: "",

    execution_time: "09:00",

    pending_work_strategy:
        "MARK_OVERDUE_AND_CREATE",

    skip_holidays: false,

    skip_weekly_off: false,

    working_day_strategy:
        "SKIP",

    remarks: ""

});

async function loadWork(workId) {

    try {

        const work =
            await wmsWorkService.getWork(workId);

        console.log(
            "Loaded Work",
            work
        );

        setForm((prev) => ({

            ...prev,

            work_mode:
                work.work_mode || "ADHOC",

            title:
                work.title || "",

            description:
                work.description || "",

            template_id:
                work.template_id || "",

            team_id:
                work.team_id || "",

            priority:
                work.priority || "MEDIUM",

            planned_due_date:
                work.planned_due_date
                    ? work.planned_due_date.substring(0, 10)
                    : "",

            estimated_minutes:
                work.estimated_minutes || "",

            remarks:
                work.remarks || "",

            is_recurring:
                work.is_recurring,

            calendar_id:
                work.calendar_id || "",

            sla_policy_id:
                work.sla_policy_id || "",

            escalation_policy_id:
                work.escalation_policy_id || ""

        }));

        if (work.team_id) {

            await loadTeamMembers(
                work.team_id
            );

        }

        if (
    work.work_mode === "TEMPLATE"
    &&
    work.template_id
) {

    const items =
        await loadTemplate(
            work.template_id
        );

    setSelectedTemplateItems(

        work.selected_template_item_ids || []

    );

}

        const assignments =
          await wmsWorkService.getAssignments(
              workId
          );

      const executors =
          assignments
              .filter(
                  x =>
                      x.assignment_role ===
                      "EXECUTOR"
              )
              .map(
                  x => String(x.user_id)
              );

      const owners =
          assignments
              .filter(
                  x =>
                      x.assignment_role ===
                      "OWNER"
              )
              .map(
                  x => String(x.user_id)
              );

      const approvers =
          assignments
              .filter(
                  x =>
                      x.assignment_role ===
                      "APPROVER"
              )
              .map(
                  x => String(x.user_id)
              );

      setSelectedMembers(
          executors
      );

      setSelectedOwners(
          owners
      );

      setSelectedApprovers(
          approvers
      );

      // =====================================================
      // LOAD RECURRING SCHEDULE
      // =====================================================

      console.log(
                "Recurring Schedule",
                work.schedule
            );
      if (
          work.is_recurring &&
          work.schedule
      ) {
          
          setSchedule({

              schedule_name:
                  work.schedule.schedule_name || "",

              frequency:
                  work.schedule.frequency || "DAILY",

              interval_value:
                  work.schedule.interval_value || 1,

              start_date:
                  work.schedule.start_date
                      ? work.schedule.start_date.substring(0, 10)
                      : "",

              end_date:
                  work.schedule.end_date
                      ? work.schedule.end_date.substring(0, 10)
                      : "",

              execution_time:
                  work.schedule.execution_time
                      ? work.schedule.execution_time.substring(0, 5)
                      : "09:00",

              pending_work_strategy:
                  work.schedule.pending_work_strategy ||
                  "MARK_OVERDUE_AND_CREATE",

              skip_holidays:
                  work.schedule.skip_holidays,

              skip_weekly_off:
                  work.schedule.skip_weekly_off,

              working_day_strategy:
                  work.schedule.working_day_strategy ||
                  "SKIP",

              remarks:
                  work.schedule.remarks || ""

          });

      }

      // =====================================================
      // LOAD ATTACHED CHECKLISTS (ADHOC)
      // =====================================================

      if (work.work_mode === "ADHOC") {

          const checklistMappings =
              await wmsWorkService.getWorkChecklists(
                  workId
              );

          setAttachedChecklists(

          checklistMappings.map(mapping => ({

              id: mapping.checklist_id,

              checklist_name:
                  mapping.checklist_name,

              mandatory:
                  mapping.mandatory,

              sequence_no:
                  mapping.sequence_no

          }))

      );

      }

    } catch (err) {

        console.error(
            "Failed to load work",
            err
        );

    }

}

async function loadMasters() {

  try {

    const templateData =
      await wmsTemplateService
        .listTemplates();

    
    setTemplates(
      templateData.items || []
    );

    const checklistData =
      await wmsChecklistService
        .listChecklists();

    setChecklists(
      checklistData.items || []
    );

    const teamData =
  await wmsTeamService
    .listTeams();

console.log(
  "Teams Response",
  teamData
);
setTeams(
  teamData.items || []
);

const members =
  await wmsTeamService
    .getAllMembers();

console.log(
  "All Team Members",
  members
);

setAllTeamMembers(
  members || []
);


  } catch (err) {

    console.error(err);

  }
}

async function loadTemplate(
  templateId
) {

  if (!templateId) {

    setSelectedTemplate(null);

    setTemplateItems([]);

    setSelectedTemplateItems([]);

    return;
}

  try {

    const template =
      await wmsTemplateService
        .getTemplate(
          templateId
        );

    setSelectedTemplate(
      template
    );

    if (!schedule.schedule_name) {

      setSchedule((old) => ({

          ...old,

          schedule_name:
              template.template_name

      }));

  }
    const items =
    await wmsTemplateService
        .getTemplateItems(
            templateId
        );

console.log(
    "Template Items",
    items
);

setTemplateItems(
    items || []
);

if (!isEdit) {

    setSelectedTemplateItems(

        (items || []).map(
            item => item.id
        )

    );

}

return items || [];

  } catch (err) {

    console.error(err);

  }
}
async function loadTeamMembers(
  teamId
) {

  if (!teamId) {

    setTeamMembers([]);

    setSelectedMembers([]);

    return;
  }

  try {

    const members =
      await wmsTeamService
        .getMembers(
          teamId
        );

    console.log(
      "Team Members",
      members
    );

    setTeamMembers(
      members || []
    );

  } catch (err) {

    console.error(err);

  }
}

function addChecklist() {

  if (!selectedChecklistId) {
    return;
  }

  const checklist =
    checklists.find(
      (x) =>
        String(x.id) ===
        String(
          selectedChecklistId
        )
    );

  if (!checklist) {
    return;
  }

  const alreadyExists =
    attachedChecklists.some(
      (x) =>
        x.id === checklist.id
    );

  if (alreadyExists) {
    return;
  }

  setAttachedChecklists([
    ...attachedChecklists,
    checklist,
  ]);

  setSelectedChecklistId("");
}  
function removeChecklist(
  checklistId
) {

  setAttachedChecklists(

    attachedChecklists.filter(
      (x) =>
        x.id !== checklistId
    )

  );
}
function handleChange(
    field,
    value
) {

    setForm((prev) => {

        const updated = {

            ...prev,

            [field]: value

        };

        if (
            field === "title"
            &&
            !schedule.schedule_name
        ) {

            setSchedule((old) => ({

                ...old,

                schedule_name: value

            }));

        }
        if (
          field === "planned_due_date"
          &&
          !schedule.start_date
      ) {

          setSchedule((old) => ({

              ...old,

              start_date: value

          }));

      }

        return updated;

    });

}
  
async function handleSave() {

  try {

    // =====================================================
    // BASIC VALIDATION
    // =====================================================

    if (!form.planned_due_date) {

        alert("Due Date is required.");

        return;

    }

    if (!form.estimated_minutes) {

        alert("Estimated Minutes is required.");

        return;

    }
    
    // =====================================================
    // RECURRING VALIDATION
    // =====================================================

    if (form.is_recurring) {

        if (!schedule.schedule_name) {

            alert(
                "Schedule Name is required."
            );

            return;

        }

        if (!schedule.start_date) {

            alert(
                "Start Date is required."
            );

            return;

        }

        if (!schedule.execution_time) {

            alert(
                "Execution Time is required."
            );

            return;

        }

    }
    
    
    if (
    form.work_mode === "TEMPLATE" &&
    selectedTemplateItems.length === 0
) {

    alert(
        "Please select at least one work item."
    );

    return;

}
    setSaving(true);
    await new Promise(resolve => setTimeout(resolve, 0));

    const payload = {

    ...form,
    selected_template_item_ids:
        selectedTemplateItems,

    calendar_id:
        form.calendar_id || null,

    sla_policy_id:
        form.sla_policy_id || null,

    escalation_policy_id:
        form.escalation_policy_id || null,

    team_id:
        form.team_id || null,

    template_id:
        form.template_id || null,

    executors: selectedMembers,

    owners: selectedOwners,

    approvers: selectedApprovers,

    checklist_ids:
        attachedChecklists.map(
            x => x.id
        )
};
if (form.is_recurring) {

    payload.schedule = schedule;

}

    console.log("Payload", payload);

    let work;

// =====================================================
// EDIT
// =====================================================

if (isEdit) {

    work =
        await wmsWorkService.updateWork(
            id,
            payload
        );

}

// =====================================================
// CREATE
// =====================================================

else if (form.work_mode === "TEMPLATE") {

    work =
        await wmsWorkService.createWorkFromTemplate(
            payload
        );

}

else {

    work =
        await wmsWorkService.createAdhocWork(
            payload
        );

}

    console.log(
      "Work Created",
      work
    );

    alert(
      "Work created successfully."
    );

    navigate("/wms/works");

  } catch (err) {

    console.error(err);

    alert(
      err?.response?.data?.message ||
      "Failed to create work."
    );

  } finally {

    setSaving(false);

  }

}

  return (

    <div className="container-fluid">

      {saving && (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
                background: "rgba(255,255,255,0.6)",
                zIndex: 9999
            }}
        >
            <div className="card shadow p-4 text-center">

                <div
                    className="spinner-border text-primary mx-auto"
                    style={{
                        width: "4rem",
                        height: "4rem"
                    }}
                ></div>

                <h5 className="mt-3 mb-1">
                    Creating Work...
                </h5>

                <small className="text-muted">
                    Please wait while we save the work.
                </small>

            </div>
        </div>
    )}

      {/* ==================================================== */}
      {/* HEADER */}
      {/* ==================================================== */}

      <div
        className="card border-0 mb-3"
        style={{
          background:
            "linear-gradient(90deg,#0d6efd,#4f8cff)",
          color: "#fff",
        }}
      >

        <div className="card-body">

          <h3 className="mb-1">

            {isEdit
              ? "Edit Work"
              : "Create Work"}

          </h3>

          <div>

            Create and manage
            work orders

          </div>

        </div>

      </div>

      {/* ==================================================== */}
      {/* BASIC INFORMATION */}
      {/* ==================================================== */}

      <div className="card">

        <div className="card-header">

          <strong>
            Basic Information
          </strong>

        </div>

        <div className="card-body">

          <div className="row">

            <div className="col-md-3 mb-3">

                <label>
                    Work Mode
                </label>

                <select
                    className="form-control"
                    value={form.work_mode}
                    onChange={(e) =>
                    handleChange(
                        "work_mode",
                        e.target.value
                    )
                    }
                >

                    <option value="ADHOC">
                    Adhoc
                    </option>

                    <option value="TEMPLATE">
                    Template Based
                    </option>

                </select>

                </div>

                {form.work_mode === "TEMPLATE" && (

                <div className="col-md-4 mb-3">

                    <label>
                    Template *
                    </label>

                    <select
                    className="form-control"
                    value={form.template_id}
                   onChange={(e) => {

                    const value =
                      e.target.value;

                    handleChange(
                      "template_id",
                      value
                    );

                    loadTemplate(
                      value
                    );

                  }}
                    >

                    <option value="">
                      Select Template
                    </option>

                    {templates.map((template) => (

                      <option
                        key={template.id}
                        value={template.id}
                      >

                        {template.template_name}

                      </option>

                    ))}

                    </select>

                </div>

                )}

            <div className="col-md-6 mb-3">

              <label>
                Title *
              </label>

              <input
                className="form-control"
                value={form.title}
                onChange={(e) =>
                  handleChange(
                    "title",
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-3 mb-3">

              <label>
                Priority
              </label>

              <select
                className="form-control"
                value={form.priority}
                onChange={(e) =>
                  handleChange(
                    "priority",
                    e.target.value
                  )
                }
              >

                <option value="LOW">
                  Low
                </option>

                <option value="MEDIUM">
                  Medium
                </option>

                <option value="HIGH">
                  High
                </option>

              </select>

            </div>

            <div className="col-md-12 mb-3">

              <label>
                Description
              </label>

              <textarea
                rows="3"
                className="form-control"
                value={form.description}
                onChange={(e) =>
                  handleChange(
                    "description",
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-4 mb-3">

              <label>
                Due Date
              </label>

              <input
                type="date"
                className="form-control"
                value={
                  form.planned_due_date
                }
                onChange={(e) =>
                  handleChange(
                    "planned_due_date",
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-4 mb-3">

              <label>
                Estimated Minutes
              </label>

              <input
                type="number"
                className="form-control"
                value={
                  form.estimated_minutes
                }
                onChange={(e) =>
                  handleChange(
                    "estimated_minutes",
                    e.target.value
                  )
                }
              />

            </div>

          </div>

        </div>

      </div>

      
      {form.work_mode === "TEMPLATE" && (

    <div className="card mt-3">

        <div className="card-header">

        <strong>
            Template Preview
        </strong>

        </div>

        <div className="card-body">

        <div className="alert alert-info mb-0">

            {selectedTemplate ? (

              <div>

                <div>

                  <strong>
                    Template Name:
                  </strong>

                  {" "}

                  {
                    selectedTemplate
                      .template_name
                  }

                </div>

                <div>

                  <strong>
                    Category:
                  </strong>

                  {" "}

                  {
                    selectedTemplate
                      .category
                  }

                </div>

                <div>

                  <strong>
                    Description:
                  </strong>

                  {" "}

                  {
                    selectedTemplate
                      .description
                  }

                </div>

              </div>

            ) : (

              <div
                className="
                  alert
                  alert-info
                  mb-0
                "
              >

                Select template
                to preview details.

              </div>

            )}

        </div>

        </div>

    </div>

    )}
      {form.work_mode === "TEMPLATE" && (

  <div className="card mt-3">

    <div className="card-header">

      <strong>
        Generated Work Items
      </strong>

    </div>

    <div className="card-body">

      <div className="alert alert-secondary mb-0">

        <table
  className="
    table
    table-sm
    table-bordered
    mb-0
  "
>

  <thead>

  <tr>

      <th width="50">

          <input
              type="checkbox"
              disabled={isEdit}
              checked={
                  templateItems.length > 0 &&
                  selectedTemplateItems.length === templateItems.length
              }
              onChange={(e) => {

                  if (e.target.checked) {

                      setSelectedTemplateItems(

                          templateItems.map(
                              item => item.id
                          )

                      );

                  } else {

                      setSelectedTemplateItems([]);

                  }

              }}
          />

      </th>

      <th>#</th>

      <th>Work Item</th>

      <th>Priority</th>

      <th>Minutes</th>

      <th>Mandatory</th>

  </tr>

  </thead>

  <tbody>

    {templateItems.length === 0 && (

      <tr>

        <td
          colSpan="6"
          className="text-center"
        >
          No Items
        </td>

      </tr>

    )}

    {templateItems.map(
      (item, index) => (

      <tr key={item.id}>

  <td>

    <input
      type="checkbox"
      checked={selectedTemplateItems.includes(item.id)}
      disabled={isEdit}
      onChange={(e) => {

        if (e.target.checked) {

          setSelectedTemplateItems(prev => [

            ...prev,
            item.id

          ]);

        } else {

          setSelectedTemplateItems(

            prev =>
              prev.filter(
                id => id !== item.id
              )

          );

        }

      }}
    />

  </td>

  <td>
    {item.sequence_no}
  </td>

  <td>
    {item.item_title}
  </td>

  <td>
    {item.default_priority}
  </td>

  <td>
    {item.estimated_minutes}
  </td>

  <td>
    {item.mandatory ? "Yes" : "No"}
  </td>

</tr>

    ))}

  </tbody>

</table>

      </div>

    </div>

  </div>

)}
{form.work_mode === "ADHOC" && (

  <div className="card mt-3">

    <div className="card-header">

      <strong>
        Checklist Selection
      </strong>

    </div>

    <div className="card-body">

      <div className="row">

  <div className="col-md-8">

    <label>
      Checklist
    </label>

    <select
      className="form-control"
      value={
        selectedChecklistId
      }
      onChange={(e) =>
        setSelectedChecklistId(
          e.target.value
        )
      }
    >

      <option value="">
        Select Checklist
      </option>

      {checklists.map(
        (checklist) => (

        <option
          key={checklist.id}
          value={checklist.id}
        >

          {
            checklist.checklist_name
          }

        </option>

      ))}

    </select>

  </div>

  <div
    className="
      col-md-4
      d-flex
      align-items-end
    "
  >

    <button
      type="button"
      className="
        btn
        btn-primary
      "
      onClick={addChecklist}
    >
      Add Checklist
    </button>

  </div>

</div>

<hr />

<h6>
  Attached Checklists
</h6>
{isEdit && (

    <div className="alert alert-info">

        Template items cannot be modified after work creation.

    </div>

)}
<table
  className="
    table
    table-sm
    table-bordered
    mb-0
  "
>

  <thead>

  <tr>

    <th width="80">
      #
    </th>

    <th>
      Checklist Name
    </th>

    <th width="120">
      Action
    </th>

  </tr>

</thead>

  <tbody>

    {attachedChecklists.length === 0 && (

      <tr>

        <td
          colSpan="3"
          className="text-center"
        >
          No Checklists Added
        </td>

      </tr>

    )}

    {attachedChecklists.map(
      (
        checklist,
        index
      ) => (

      <tr key={checklist.id}>

  <td>
    {index + 1}
  </td>

  <td>
    {
      checklist.checklist_name
    }
  </td>

  <td>

    <button
      type="button"
      className="
        btn
        btn-sm
        btn-danger
      "
      onClick={() =>
        removeChecklist(
          checklist.id
        )
      }
    >
      Remove
    </button>

  </td>

</tr>

    ))}

  </tbody>

</table>

    </div>

  </div>

)}
      
      {/* ==================================================== */}
      {/* RECURRING WORK */}
      {/* ==================================================== */}

      <div className="card mt-3">

        <div className="card-header">

          <strong>
            Recurring Work
          </strong>

        </div>

        <div className="card-body">

          <div className="form-check">

            <input
              type="checkbox"
              className="form-check-input"
              checked={form.is_recurring}
              onChange={(e) =>
                handleChange(
                  "is_recurring",
                  e.target.checked
                )
              }
            />

            <label className="form-check-label">
              Is Recurring Work
            </label>

          </div>

        </div>

      </div>
              <RecurringScheduleCard

                enabled={
                    form.is_recurring
                }

                schedule={schedule}

                setSchedule={
                    setSchedule
                }

            />
      {/* ==================================================== */}
      {/* ASSIGNMENT */}
      {/* ==================================================== */}

      <div className="card mt-3">

        <div className="card-header">

          <strong>
            Assignment
          </strong>

        </div>

        <div className="card-body">

          <div className="row">

            

            <div className="col-md-6 mb-3">

  <label>
    Execution Team *
  </label>

  <select
    className="form-control"
    value={form.team_id}
    onChange={(e) => {

      const teamId =
        e.target.value;

      handleChange(
        "team_id",
        teamId
      );

      loadTeamMembers(
        teamId
      );

    }}
  >

    <option value="">
      Select Team
    </option>

    {teams.map((team) => (

      <option
        key={team.id}
        value={team.id}
      >

        {team.team_name}

      </option>

    ))}

  </select>

</div>

<div className="col-md-6 mb-3">

  <label>
    Executors *
  </label>

  <select
  multiple
  className="form-control"
  style={{
    minHeight: "120px"
  }}
  value={selectedMembers}
  onChange={(e) => {

    const values =
      Array.from(
        e.target.selectedOptions
      ).map(
        option => option.value
      );

    setSelectedMembers(
      values
    );

    console.log(
      "Selected Members",
      values
    );

  }}
>

  {teamMembers.map(
    (member) => (

    <option
      key={member.id}
      value={member.id}
    >

      {member.member_name}
      {" - "}
      {member.member_code}

    </option>

  ))}

</select>
</div>

</div>

<hr className="my-3" />

<div className="row">

<div className="col-md-6 mb-3">

  <label>
    Owners
  </label>

  <select
    multiple
    className="form-control"
    style={{
      minHeight: "170px"
    }}
    value={selectedOwners}
    onChange={(e) => {

      const values =
        Array.from(
          e.target.selectedOptions
        ).map(
          option => option.value
        );

      setSelectedOwners(
        values
      );

    }}
  >

    {allTeamMembers.map(
      (member) => (

      <option
        key={member.id}
        value={member.id}
      >

        {member.member_name}
        {" ("}
        {member.team_name}
        {")"}

      </option>

    ))}

  </select>

</div>


<div className="col-md-6 mb-3">

  <label>
    Approvers
  </label>

  <select
    multiple
    className="form-control"
    style={{
      minHeight: "170px"
    }}
    value={selectedApprovers}
    onChange={(e) => {

      const values =
        Array.from(
          e.target.selectedOptions
        ).map(
          option => option.value
        );

      setSelectedApprovers(
        values
      );

    }}
  >

    {allTeamMembers.map(
      (member) => (

      <option
        key={member.id}
        value={member.id}
      >

        {member.member_name}
        {" ("}
        {member.team_name}
        {")"}

      </option>

    ))}

  </select>

</div>


          </div>

        </div>

      </div>

      {/* ==================================================== */}
{/* WATCHERS */}
{/* ==================================================== */}

<div className="card mt-3">

  <div className="card-header">

    <strong>
      Watchers
    </strong>

  </div>

  <div className="card-body">

    <div className="alert alert-info mb-0">

      Watcher selection will be
      implemented after user APIs
      are connected.

    </div>

  </div>

</div>
      {/* ==================================================== */}
      {/* SLA */}
      {/* ==================================================== */}

      <div className="card mt-3">

        <div className="card-header">

          <strong>
            SLA / Escalation
          </strong>

        </div>

        <div className="card-body">

          <div className="row">

            <div className="col-md-4 mb-3">

              <label>
                SLA Policy
              </label>

              <input
                className="form-control"
                value={
                  form.sla_policy_id
                }
                onChange={(e) =>
                  handleChange(
                    "sla_policy_id",
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-4 mb-3">

              <label>
                Escalation Policy
              </label>

              <input
                className="form-control"
                value={
                  form.escalation_policy_id
                }
                onChange={(e) =>
                  handleChange(
                    "escalation_policy_id",
                    e.target.value
                  )
                }
              />

            </div>

            <div className="col-md-4 mb-3">

              <label>
                Calendar
              </label>

              <input
                className="form-control"
                value={
                  form.calendar_id
                }
                onChange={(e) =>
                  handleChange(
                    "calendar_id",
                    e.target.value
                  )
                }
              />

            </div>

          </div>

        </div>

      </div>





      {/* ==================================================== */}
      {/* FOOTER */}
      {/* ==================================================== */}

      <div className="card mt-3">

        <div className="card-body text-end">

          <button
              className="btn btn-primary me-2"
              onClick={handleSave}
              disabled={saving}
          >
              {saving ? (
                  <>
                      <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                      ></span>
                      {isEdit ? "Updating Work..." : "Creating Work..."}
                  </>
              ) : (
                  isEdit ? "Update" : "Save"
              )}
          </button>

          <button
            className="btn btn-secondary"
            onClick={() =>
              navigate(
                "/wms/works"
              )
            }
          >
            Cancel
          </button>

        </div>

      </div>

    </div>
  );
}